import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';
import { Marca } from '../../../../model/class/Marca';
import { MarcaService } from '../../../services/marca/marca.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { CrearMarcaComponent } from '../crear-marca/crear-marca.component';

@Component({
  selector: 'app-listado-marcas',
  templateUrl: './listado-marcas.component.html',
  styleUrls: ['./listado-marcas.component.css']
})
export class ListadoMarcasComponent implements OnInit {

  loader = {
    tabla: false
  };

  textoBuscar: string;
  textoBuscarChanged: Subject<string> = new Subject<string>();

  page = 1;
  perPage = 20;
  totalData = 0;
  orderSelected: any;
  marcasTodas: Marca[] = [];

  headerTable: any[] = [
    {
      text: 'Marca',
      value: 'nombre'
    }, {
      text: 'Productos',
      value: 'totalProductos'
    }
  ];

  constructor(
    private modalService: NgbModal,
    private marcaService: MarcaService
  ) {
    this.textoBuscarChanged
      .pipe(debounceTime(500)) // wait 1 sec after the last event before emitting last event
      .subscribe(model => {
        this.textoBuscar = model.toString();
        this.loadMarcas();
      });
  }

  ngOnInit() {
    this.loadMarcas();
  }

  onTextoBuscarChange(texto: string) {
    this.textoBuscarChanged.next(texto);
  }

  private loadMarcas() {
    this.loader.tabla = true;
    this.marcasTodas = [];
    const parametros: any = {};
    let texto: string;

    if (this.textoBuscar) {
      texto = this.textoBuscar.trim();
    }
    if (texto) {
      const objetoBucar: any = [{ 'name': texto }];
      parametros.search = JSON.stringify(objetoBucar);
    }
    const paginador = {
      since: (this.page - 1) * this.perPage,
      quantity: this.perPage
    };
    parametros.paginator = JSON.stringify(paginador);

    this.marcaService.all(parametros)
      .subscribe(
        (response) => {
          this.loader.tabla = false;
          this.totalData = response.total;
          for (const iMar of response.data) {
            this.marcasTodas.push(new Marca(iMar));
          }
          this.orderData();
        }, (error) => {
          this.loader.tabla = false;
        }
      );
  }

  limpiarTexto() {
    this.textoBuscar = '';
    this.loadMarcas();
  }

  changeValueOrder(index: number) {
    if (this.headerTable[index].value) {
      for (let i = 0; i < this.headerTable.length; i++) {
        if (i === index) {
          if (this.headerTable[i].order === 'desc') {
            this.headerTable[i].order = 'asc';
          } else if (this.headerTable[i].order === 'asc') {
            this.headerTable[i].order = 'desc';
          } else if (!this.headerTable[i].order) {
            this.headerTable[i].order = 'asc';
          }
        } else {
          this.headerTable[i].order = undefined;
        }
      }
      this.orderSelected = this.headerTable[index];
      this.orderData();
    }
  }

  orderData() {
    if (this.orderSelected) {
      this.marcasTodas = _.orderBy(this.marcasTodas, this.orderSelected.value, this.orderSelected.order);
    }
  }

  pageChange(event) {
    this.page = event;
    this.loadMarcas();
  }


  crearEditarMarca(marca?: Marca) {
    let clon: any = {};
    if (marca) {
      clon = _.clone(marca);
    }

    const viewModal = this.modalService.open(CrearMarcaComponent, { size: 'lg', windowClass: 'modal-admin' });
    viewModal.componentInstance.newMarca = clon;

    viewModal.result
      .then((newMarca: Marca) => {
        const newObj = new Marca(newMarca);
        if (clon.id) {
          // Editando
          const indice = _.findIndex(this.marcasTodas, { id: newObj.id });
          if (indice >= 0) {
            this.marcasTodas[indice] = newObj;
          }
        } else {
          // Nuevo
          if (this.marcasTodas.length < this.perPage) {
            this.marcasTodas.push(newObj);
          }
        }
      }, (reason) => {
      });

  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/listado-marcas/listado-marcas.component.ts